module.exports = __webpack_public_path__ + "img/header-logo.2af6152a.jpg";